// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */

import { createAsyncAction } from 'typesafe-actions';

import { LabInformation } from '../../types/Model';

export interface LabInformationRequestPayload {
  id: number;
  condition: string;
  workshopId?: number;
  iltCourseId?: number;
  preventLoading?: boolean;
}
export interface LabInformationSuccessPayload {
  labInformation: LabInformation;
}

export interface LabInformationFailPayload {
  error: Error;
}

export const getLabInformationActions = createAsyncAction(
  'elearning/GET_LAB_INFORMATION',
  'elearning/GET_LAB_INFORMATION_SUCCESS',
  'elearning/GET_LAB_INFORMATION_FAIL'
)<LabInformationRequestPayload, LabInformationSuccessPayload, LabInformationFailPayload>();
